/**
 * "Get link…": the link card (`LinkPanel`) in a modal — the link, the QR
 * code and the three embed snippets, one click from any form tab and from
 * the forms list. Since R7 the card itself lives on Distribute › Link &
 * access, where it also carries the Prefilled link tab; this is the same
 * card without it.
 *
 * Named to stay clear of ShareDialog, which is TEAM sharing (who in the
 * account may reach the form). This is respondent distribution — the public
 * link and nothing about access. The two vocabularies meet in the footnote.
 */
import { Link } from 'react-router-dom';
import { Modal } from '../../components/fs';
import LinkPanel, { distributionSnippets } from './LinkPanel';
import type { DistributeTarget } from './LinkPanel';
import type { FormAccess } from '../../shared/types';

export { distributionSnippets };
export type { DistributeTarget };

export default function DistributeDialog({ form, accountSlug, publicBaseUrl, platformBaseUrl, accessMode, onClose }: {
  form: DistributeTarget;
  accountSlug: string;
  /** the origin share links build on: the account's live custom domain, else the platform's */
  publicBaseUrl?: string | null;
  /** the platform's own public origin, for a form a custom domain cannot serve */
  platformBaseUrl?: string | null;
  accessMode?: FormAccess['mode'] | null;
  onClose: () => void;
}) {
  return (
    <Modal
      title={<>Get the link to <b>{form.name}</b></>} onClose={onClose}
      footer={<button className="fs-btn neutral" onClick={onClose}>Close</button>}
    >
      <LinkPanel
        form={form} accountSlug={accountSlug} publicBaseUrl={publicBaseUrl}
        platformBaseUrl={platformBaseUrl} accessMode={accessMode}
      />

      {/* The two vocabularies, kept apart in the one place they meet. */}
      <div className="fs-cell-sub faint" style={{ marginTop: 16 }}>
        This is the public link — who may FILL IN the form, and a link with answers already filled in, are on{' '}
        <Link to={`/admin/forms/${form.id}/access`}>Link & access</Link>. Who in your
        account can reach it here is “Share…”.
      </div>
    </Modal>
  );
}
